import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
import Header from './Header';
import Footer from './Footer';
import Container from './Container';

const PageLayout = ({
  children,
  showHeader = true,
  showFooter = true,
  containerSize = 'default',
  className = '',
  animate = true,
}) => {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  };

  const content = animate ? (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
      transition={{ duration: 0.3 }}
      className={cn('flex-1', className)}
    >
      {children}
    </motion.div>
  ) : (
    <div className={cn('flex-1', className)}>{children}</div>
  );

  return (
    <div className="flex flex-col min-h-screen">
      {showHeader && <Header />}
      <main className={cn('flex-1', showHeader && 'pt-24')}>
        <Container size={containerSize}>{content}</Container>
      </main>
      {showFooter && <Footer />}
    </div>
  );
};

export default PageLayout;

